import React from 'react'
import {Col, Container, Row} from "react-bootstrap";
import {GetText} from "../../context/text.js";

function Footer() {
    let text = GetText();

    return (
        <div className="padTop">
            <div className="topInfoFooter">
                <footer>
                    <Container>
                        <Row className="center-text padTop padBottom">
                            <Col>
                                <p>
                                    Copyright &copy; {text.Footer.title} 2015-{new Date().getFullYear()}. Powered by{" "}
                                    <a title="yarti7@gmail.com" href="mailto:yarti7@gmail.com">YARTI</a>.
                                </p>

                                <div style={{ marginTop: "10px", fontSize: "14px" }}>
                                    <a href="/oferta" style={{ marginRight: "15px", color: "#ccc" }}>
                                        Договір оферти
                                    </a>
                                    <a href="/privacy-policy" style={{ color: "#ccc" }}>
                                        Політика конфіденційності
                                    </a>
                                </div>

                                <a
                                    style={{
                                        color: "#F8F8F8",
                                        backgroundColor: "#F8F8F8",
                                        textDecoration: "none",
                                        display: "inline-block",
                                        padding: "0",
                                        margin: "0",
                                        lineHeight: "1"
                                    }}
                                    href="/allcatalog"
                                >
                                    .
                                </a>
                            </Col>
                        </Row>
                    </Container>
                </footer>
            </div>
        </div>

    )
}

export default Footer
